import { Link } from "react-router-dom";
import '../../styles/NewsStyles/News.css';
import NewsCard from "./NewsCard";
import NewsComingSoon from "./NewsComingSoon";
import { hasLivePosts, listPosts } from "../../news/posts";

const HOMEPAGE_COUNT = 4;

// Homepage preview of the newest articles. Until the first one is published, a "coming soon"
// card holds its place (the development server also lists drafts beside it, labelled).
const LatestNews = () => {
    const comingSoon = !hasLivePosts();
    const posts = listPosts().slice(0, comingSoon ? HOMEPAGE_COUNT - 1 : HOMEPAGE_COUNT);

    return (
        <section className="km-section km-section--brand nw-home" id="news" aria-labelledby="nw-home-title">
            <div className="km-container">
                <div className="km-sectionHead km-sectionHead--center" data-reveal>
                    <p className="km-eyebrow">News</p>
                    <h2 className="km-title" id="nw-home-title">Latest news and updates</h2>
                    <p className="km-lead">
                        Updates from Kole Medical on medical devices, SAHPRA licensing and our upcoming webinars.
                    </p>
                </div>
                <div className="km-cardRow nw-home-grid">
                    {comingSoon && <NewsComingSoon eventsLink="/events" />}
                    {posts.map((post, index) => (
                        <NewsCard key={post.slug} post={post} revealOrder={index + (comingSoon ? 1 : 0)} headingLevel={3} />
                    ))}
                </div>
                <div className="nw-home-cta">
                    <Link className="km-btn km-btn--outlineLight" to="/news">
                        View all news <span className="km-arrow" aria-hidden="true">→</span>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default LatestNews;
